import { render, staticRenderFns } from "./AccessRequests.vue?vue&type=template&id=5590271a&scoped=true&"
import script from "./AccessRequests.vue?vue&type=script&lang=js&"
export * from "./AccessRequests.vue?vue&type=script&lang=js&"
import style0 from "./AccessRequests.vue?vue&type=style&index=0&id=5590271a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5590271a",
  null
  
)

export default component.exports